import * as React from "react";
import type { SVGProps } from "react";
const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.193 12A4.21 4.21 0 0 1 7.81 8.45l-.12-2.18C7.69 3.89 9.58 2 11.9 2h.19c2.32 0 4.21 1.89 4.21 4.22l-.13 2.24A4.18 4.18 0 0 1 13.814 12H17c2.76 0 5 2.24 5 5v4c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-4c0-2.76 2.24-5 5-5zM18 20v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H8v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H4v-3c0-1.65 1.35-3 3-3h10c1.65 0 3 1.35 3 3v3zM9.69 6.22c0-1.23.99-2.22 2.21-2.22h.19c1.22 0 2.22.99 2.22 2.16l-.12 2.18A2.2 2.2 0 0 1 12 10.41a2.2 2.2 0 0 1-2.19-2.07z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPerson;
